import styled from "styled-components";

export const ChatInputContainer = styled.div`
  border-radius: 20px;

  > form {
    position: relative;
    display: flex;
    justify-content: center;
  }

  > form > input {
    position: fixed;
    bottom: 30px;
    left: 20px;
    width: 60%;
    border: 1px solid gray;
    border-radius: 30px;
    padding: 15px;
    outline: none;

    @media (min-width: 1000px) {
      padding: 20px;
      margin-left: 20%;
    }
  }

  > form > button {
    position: fixed;
    bottom: 35px;
    right: 10px;
    border: 1px solid gray;
    border-radius: 30px;
    background-color: lightblue;

    @media (min-width: 1000px) {
      display: none !important;
    }
  }
`;
